export default {
  getPhonePrefix: function (countryId) {
    let prefix = '';
    switch (parseInt(countryId)) {
      case 16:
        prefix = '+420';
        break;
      case 37:
        prefix = '+421';
        break;
      case 143:
        prefix = '+36';
        break;
      case 1:
        prefix = '+49';
        break;
      case 14:
        prefix = '+48';
        break;
      case 2:
        prefix = '+43';
        break;
      case 36:
        prefix = '+40';
        break;
    }
    return prefix;
  }
}